import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

export const Address: FunctionComponent = () => {
  return (
    <Box>
      <Typography variant="body2" color="textSecondary">
        Edubite sp. z o.o.
      </Typography>
      <Typography variant="body2" color="textSecondary">
        NIP: 6751748512
      </Typography>
      <Typography variant="body2" color="textSecondary">
        ul. Olszańska 7
      </Typography>
      <Typography variant="body2" color="textSecondary">
        31-513 Kraków
      </Typography>
      <Typography variant="body2" color="textSecondary">
        kontakt@matematykagryzie.pl
      </Typography>
    </Box>
  );
};

export default Address;
